<template>
  <div class="hidden">
    <vs-sidebar
        ref="sidebar"
        v-model="active"
        :reduce="$store.state.sideBarCollapse"
        open
    >
      <template #logo v-if="!$store.state.sideBarCollapse">
        <img src="../assets/logistic.png"/>
        <h4
            :style="{ marginLeft: '10px', fontSize: '18px', fontWeight: 'bold' }"
        >
          {{ $t("Sidebar.ຮຸ່ງອາລຸນ ຂົນສົ່ງດວ່ນ") }}
        </h4>
      </template>

      <!-- ProvinceManager -->
      <vs-sidebar-group v-if="$can(['province-manager'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-map"></i>
            </template>
            {{ $t("Sidebar.ຫົວໜ້າແຂວງ") }}
          </vs-sidebar-item>
        </template>

        <div v-if="$can(['province-manager'])">
          <vs-sidebar-item
              id="tab.shipment.province.manager"
              ref="tab.shipment.province.manager"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນລາຍການ orders") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['province-manager'])">
          <vs-sidebar-item
              id="tab.solve.shipments"
              ref="tab.solve.shipments"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-engine-warning"></i>
            </template>
            {{ $t("Sidebar.ຄົ້ນຫາບິນ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['province-manager'])">
          <vs-sidebar-item id="print.all.shipment">
            <template #icon>
              <i class="fal fa-print"></i>
            </template>
            {{ $t("Sidebar.ລາຍການບິນ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <!-- ProvinceManager -->

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'manager', 'news'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-tasks-alt"></i>
            </template>
            {{ $t("Sidebar.ຈັດການຂໍ້ມູນຫຼັກ") }}
          </vs-sidebar-item>
        </template>

        <div v-if="$can(['manager', 'SuperAdmin'])">
          <vs-sidebar-item id="list.dashboard">
            <template #icon>
              <i class="fal fa-tachometer-slow"></i>
            </template>
            {{ $t("Sidebar.ໜ້າຫຼັກ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="vendor.accounts">
            <template #icon>
              <i class="fal fa-store"></i>
            </template>
            {{ $t("Sidebar.vendor_manage") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.role.users">
            <template #icon>
              <i class="fal fa-user-tag"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ Roles") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.permission.users">
            <template #icon>
              <i class="fal fa-users-class"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ Permissions") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.package.size">
            <template #icon>
              <i class="fal fa-box-full"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ປະເພດຂະໜາດເເພ໋ກເເກ໋ດ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item
              id="tab.list.packages"
              ref="tab.list.packages"
              :value="JSON.stringify({ params: { type: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-box-full"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ເເພ໋ກເເກ໋ດ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="tab.list.promotion">
            <template #icon>
              <i class="fal fa-tags"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ໂປຮໂມຮຊັ່ນ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="tab.list.coupon">
            <template #icon>
              <i class="fal fa-badge-dollar"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ຄູປ໋ອງ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.villages">
            <template #icon>
              <i class="fal fa-location-circle"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ບ້ານທັງໝົດ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.banners">
            <template #icon>
              <i class="fal fa-images"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ເເບນເນີ ( Banners )") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.parcel-categories">
            <template #icon>
              <i class="fal fa-file-certificate"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ໝວດໝູ່ພັດສະດຸ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.shipping-rates">
            <template #icon>
              <i class="fal fa-money-bill-wave"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຄາຂົນສົ່ງ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.shipping-addresses">
            <template #icon>
              <i class="fal fa-map-marker-alt"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ທີ່ຢູ່ຂົນສົ່ງ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.shipment.status">
            <template #icon>
              <i class="fal fa-journal-whills"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ສະຖານະການຈັດສົ່ງ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['SuperAdmin', 'news'])">
          <vs-sidebar-item id="list.news">
            <template #icon>
              <i class="fal fa-newspaper"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ຂ່າວສານທົ່ວໄປ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.contact-us">
            <template #icon>
              <i class="fal fa-phone-rotary"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ຕິດຕໍ່ພວກເຮົາ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group
          v-if="
          $can('SuperAdmin') ||
          $can('accountingmanager') ||
          $can('accountingcod') ||
          $can('manager')
        "
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="far fa-address-card"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນລູກຄ້າ") }}
          </vs-sidebar-item>
        </template>

        <div
            v-if="$can('SuperAdmin') || $can('accountingcod') || $can('manager')"
        >
          <vs-sidebar-item
              id="tab.general.customer"
              ref="tab.general.customer"
              :value="JSON.stringify({ query: { tab: 'general' } })"
          >
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ລູກຄ້າທົ່ວໄປ") }}
          </vs-sidebar-item>
        </div>

        <div
            v-if="
            $can('SuperAdmin') ||
            $can('callcentervipcustomer') ||
            $can('accountingcod') ||
            $can('manager')
          "
        >
          <vs-sidebar-item
              id="tab.vip.customer"
              ref="tab.vip.customer"
              :value="JSON.stringify({ query: { tab: 'pending' } })"
          >
            <template #icon>
              <i class="fal fa-user-tie"></i>
            </template>
            {{ $t("Sidebar.ລູກຄ້າ VIP") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['SuperAdmin', 'accountingmanager', 'manager'])">
          <vs-sidebar-item
              id="tab.company.customer"
              ref="tab.company.customer"
              :value="JSON.stringify({ query: { tab: 'company' } })"
          >
            <template #icon>
              <i class="fal fa-building"></i>
            </template>
            {{ $t("Sidebar.ລູກຄ້າບໍລິສັດ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.celebrate">
            <template #icon>
              <i class="fal fa-users"></i>
            </template>
            {{ $t("Sidebar.ລູກຄ້າ ວັນເປີດງານ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['SuperAdmin', 'manager'])">
          <vs-sidebar-item id="list.inactive.customers">
            <template #icon>
              <i class="fal fa-user-clock"></i>
            </template>
            {{ $t("Sidebar.ລູກຄ້າບໍ່ໄດ້ໃຊ້ແອັບ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.customer.special.pins">
            <template #icon>
              <i class="fal fa-key"></i>
            </template>
            {{ $t("Sidebar.ລະຫັດ PIN ພິເສດ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['SuperAdmin','branch-user-manage', 'distribution-center-user-manage'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-user-circle"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນພະນັກງານ") }}
          </vs-sidebar-item>
        </template>

        <div v-if="$can(['SuperAdmin','branch-user-manage'])">
          <vs-sidebar-item id="list.branch.users">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ພະນັກງານ ສາຂາ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin','distribution-center-user-manage'])">
          <vs-sidebar-item id="list.distribution.center.users">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ພະນັກງານ ສູນຄັດເເຍກ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.delivery.user">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ພະນັກງານ ( Delivery )") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.call.center.users">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ພະນັກງານ ( Call Center )") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.user.vehicle.departments">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ພະນັກງານ ພາຫະນະ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.accounting.user">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ພະນັກງານ ບັນຊີ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="list.employee">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ຜູ້ໃຊ້ອື່ນໆ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'service', 'branch-manage', 'distribution-center-manage'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-registered"></i>
            </template>
            {{ $t("Sidebar.ລົງທະບຽນ") }}
          </vs-sidebar-item>
        </template>

        <div v-if="$can(['branch-manage', 'SuperAdmin'])">
          <vs-sidebar-item
              id="list.branches"
              ref="list.branches"
              :value="JSON.stringify({ params: { type: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-users"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ສາຂາພັດສະດຸ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'distribution-center-manage'])">
          <vs-sidebar-item id="list.distribution.center">
            <template #icon>
              <i class="fal fa-users"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ສາຂາສາງຄັດເເຍກພັດສະດຸ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item id="list.deliveries">
            <template #icon>
              <i class="fal fa-motorcycle"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ສາຂາ Delivery") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item id="list.call.centers">
            <template #icon>
              <i class="fal fa-phone-rotary"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ Call-Center") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item id="list.vehicle.department">
            <template #icon>
              <i class="fal fa-truck-container"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ພະເເນກພາຫະນະ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item id="list.post_boxes">
            <template #icon>
              <i class="fal fa-boxes"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ກ່ອງໄປສະນີ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item id="route.system.index">
            <template #icon>
              <i class="fal fa-truck-container"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ສາຍທາງ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can('deliverymanager')">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-motorcycle"></i>
            </template>
            {{ $t("Sidebar.order ຂອງລູກຄ້າ") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item id="delivery.tab.order.request">
            <template #icon>
              <i class="fal fa-gift"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຍການ orders") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="delivery.list.reports">
            <template #icon>
              <i class="fal fa-chart-line"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານ ລາຍການ orders") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['branchmanager', 'franchise-manager'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-dolly-flatbed-alt"></i>
            </template>
            {{ $t("Sidebar.ລາຍການພັດສະດຸ ຂອງສາຂາ") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item
              id="branch.tab.list.order"
              ref="branch.tab.list.order"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-arrow-alt-circle-left"></i>
            </template>
            {{ $t("Sidebar.ລາຍການສ້າງ orders") }}
          </vs-sidebar-item>
          <vs-sidebar-item
              id="branch.tab.list.order.inbound"
              ref="branch.tab.list.order.inbound"
              :value="JSON.stringify({ query: { tab: 'all' } })"
              v-if="!$can('organization-manager')"
          >
            <template #icon>
              <i class="fal fa-arrow-alt-circle-right"></i>
            </template>
            {{ $t("Sidebar.ລາຍການຮັບ orders") }}
          </vs-sidebar-item>
          <div
              v-if="$can(['branchmanager', 'franchise-manager'])"
          >
            <vs-sidebar-item
                id="tab.solve.shipments"
                ref="tab.solve.shipments"
                :value="JSON.stringify({ query: { tab: 'all' } })"
            >
              <template #icon>
                <i class="fal fa-engine-warning"></i>
              </template>
              {{ $t("Sidebar.ຄົ້ນຫາບິນ") }}
            </vs-sidebar-item>
          </div>
          <div>
            <vs-sidebar-item v-if="$can(isBranchCLogisticsAccounting())"
                             id="account.tab.solve.shipments"
                             ref="account.tab.solve.shipments"
                             :value="JSON.stringify({ query: { tab: tabQueryShipment } })">
              <template #icon>
                <i class="fal fa-engine-warning"></i>
              </template>
              {{ $t("Sidebar.ຄົ້ນຫາບິນ") }}
            </vs-sidebar-item>
          </div>
          <!--          <vs-sidebar-item id="list.sign.cdc">-->
          <!--            <template #icon>-->
          <!--              <i class='fal fa-pen'></i>-->
          <!--            </template>-->
          <!--            ລາຍການຍິງເຊັນຮັບ CDC-->
          <!--          </vs-sidebar-item>-->
          <vs-sidebar-item id="list.sign.cod" v-if="$i18n.locale !== 'CN' && !$can('organization-manager')">
            <template #icon>
              <i class="fal fa-money-bill"></i>
            </template>
            {{ $t("Sidebar.ລາຍການຍິງເຊັນຮັບ COD") }}
          </vs-sidebar-item>
          <vs-sidebar-item id="list.branch.summary" v-if="$i18n.locale !== 'CN'">
            <template #icon>
              <i class="fal fa-chart-pie"></i>
            </template>
            {{ $t("Sidebar.ຍອດສາຂາ") }}
          </vs-sidebar-item>
          <vs-sidebar-item id="list.branch.employee.summary" v-if="$i18n.locale !== 'CN' && ($can('branchmanager') || $can('franchise-manager'))">
            <template #icon>
              <i class="fal fa-users"></i>
            </template>
            {{ $t("Sidebar.branch_employee_summary") }}
          </vs-sidebar-item>
          <vs-sidebar-item
              id="tab.invoice.branch"
              ref="tab.invoice.branch"
              :value="JSON.stringify({ query: { tab: 'origin' } })"
          >
            <template #icon>
              <i class="fal fa-money-check-edit"></i>
            </template>
            {{ $t("Sidebar.ອິນວອຍສາຂາ") }}
          </vs-sidebar-item>
          <vs-sidebar-item id="branch.payment" v-if="!$can('organization-manager')">
            <template #icon>
              <i class="fal fa-coin"></i>
            </template>
            {{ $t("Sidebar.ລາຍການພ້ອຍ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can('accountmanager')">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-dolly-flatbed-alt"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ Order ພັດສະດຸ") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item
              id="account.tab.list.order"
              ref="account.tab.list.order"
              :value="JSON.stringify({ query: { tab: 'origin_freight' } })"
          >
            <template #icon>
              <i class="fal fa-gift"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຍການ orders") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!-- SuperAdmin -->
      <vs-sidebar-group
          v-if="
          $can([
            'SuperAdmin',
            'callcentervipcustomer',
            'service',
            'manager',
            'marketing',
            'suburbMarketing',
            'distributioncentermanager'
          ])
        "
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-dolly-flatbed-alt"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ Order ພັດສະດຸ") }}
          </vs-sidebar-item>
        </template>

        <div
            v-if="$can(['service', 'manager', 'marketing', 'suburbMarketing', 'distributioncentermanager'])"
        >
          <vs-sidebar-item
              id="tab.all.shipments"
              ref="tab.all.shipments"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຍການ orders") }}
          </vs-sidebar-item>
        </div>

        <div
            v-if="
            $can([
              'callcentervipcustomer',
              'manager',
              'marketing',
              'suburbMarketing',
            ])
          "
        >
          <vs-sidebar-item
              id="tab.solve.shipments"
              ref="tab.solve.shipments"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-engine-warning"></i>
            </template>
            {{ $t("Sidebar.ຄົ້ນຫາບິນ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['service', 'SuperAdmin'])">
          <vs-sidebar-item id="account.tab.solve.shipments" ref="account.tab.solve.shipments"
                           :value="JSON.stringify({query: { tab: 'all' } })">
            <template #icon>
              <i class='fal fa-engine-warning'></i>
            </template>
            {{ $t("Sidebar.ຄົ້ນຫາບິນ") }}
          </vs-sidebar-item>
        </div>
        <!--        <div v-if="$can('SuperAdmin')">-->
        <!--          <vs-sidebar-item-->
        <!--              id="account.tab.solve.shipments"-->
        <!--              ref="account.tab.solve.shipments"-->
        <!--              :value="JSON.stringify({ query: { tab: 'origin_freight_fees' } })"-->
        <!--          >-->
        <!--            <template #icon>-->
        <!--              <i class="fal fa-key"></i>-->
        <!--            </template>-->
        <!--            {{ $t("Sidebar.ແກ້ໄຂບິນ") }}-->
        <!--          </vs-sidebar-item>-->
        <!--        </div>-->

        <!--        report-->
        <!--        <div v-if="$can(['SuperAdmin','accountingmanager'])">-->
        <!--          <vs-sidebar-item id="tab.report.driver" ref="tab.report.driver"-->
        <!--                           :value="JSON.stringify({query: { tab: 'all' } })">-->
        <!--            <template #icon>-->
        <!--              <i class='fal fa-truck'></i>-->
        <!--            </template>-->
        <!--            ລາຍການອໍເດີໂຊເພີລົດໃຫຍ່-->
        <!--          </vs-sidebar-item>-->
        <!--        </div>-->

        <!--        <div v-if="$can(['SuperAdmin','accountingmanager'])">-->
        <!--          <vs-sidebar-item id="tab.report.distribution" ref="tab.report.distribution"-->
        <!--                           :value="JSON.stringify({query: { tab: 'all' } })">-->
        <!--            <template #icon>-->
        <!--              <i class='fal fa-house'></i>-->
        <!--            </template>-->
        <!--            ລາຍການຍິງເຄື່ອງເຂົ້າ-ອອກ ສູນຄັດແຍກ-->
        <!--          </vs-sidebar-item>-->
        <!--        </div>-->

        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item
              id="tab.all.shipment.pre.order"
              ref="tab.all.shipment.pre.order"
              :value="JSON.stringify({ query: { tab: 'origin_freight_fees' } })"
          >
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຍການ Pre-Order") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item
              id="list.report.order.request"
              ref="list.report.order.request"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-comment-alt-lines"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຍການເອີ້ນຮັບເຄື່ອງ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['SuperAdmin', 'service', 'callcentervipcustomer'])">
          <vs-sidebar-item
              id="shipment-issue-stock"
              ref="shipment-issue-stock"
              :value="JSON.stringify({})"
          >
            <template #icon>
              <i class="fas fa-tasks"></i>
            </template>
            {{ $t("Sidebar.ກວດສອບພັດສະດຸ") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['SuperAdmin','service', 'callcentervipcustomer'])">
          <vs-sidebar-item
              id="parcel.arrived.index"
              ref="parcel.arrived.index"
              :value="JSON.stringify({})"
          >
            <template #icon>
              <i class="fas fa-tasks"></i>
            </template>
            {{ $t("Sidebar.check_parcel_arrived_branch") }}
          </vs-sidebar-item>
        </div>

        <!-- A returned PDD parcel is destroyed only on PDD's written instruction — SuperAdmin/service,
             matching the API gate on api/admin/pdd/waybills/* and the route guard. -->
        <div v-if="$can(['SuperAdmin', 'service'])">
          <vs-sidebar-item id="pdd-dispose">
            <template #icon>
              <i class="fal fa-trash-alt"></i>
            </template>
            {{ $t("Sidebar.ທຳລາຍພັດສະດຸ PDD (ຕາມຄຳສັ່ງ PDD)") }}
          </vs-sidebar-item>
        </div>

        <!-- Customer update requests, read only — `service` only, matching the API gate on
             api/admin/shipment-update-requests/* and the route guard. -->
        <div v-if="$can('service')">
          <vs-sidebar-item id="list.shipment.update.requests">
            <template #icon>
              <i class="fal fa-edit"></i>
            </template>
            {{ $t("Sidebar.ຄຳຂໍແກ້ໄຂພັດສະດຸ") }}
          </vs-sidebar-item>
        </div>


      </vs-sidebar-group>
      <!-- End SuperAdmin -->

      <!-- DistributionCenters -->
      <vs-sidebar-group
          v-if="
          $can([
            'SuperAdmin',
            'distributioncentermanager',
            'distribution',
            'service',
          ])
        "
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-house-day"></i>
            </template>
            {{ $t("Sidebar.ລາຍການພັດສະດຸ ຂອງສູນຄັດແຍກ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['distributioncentermanager'])">
          <vs-sidebar-item
              id="distribution.center.tab.all.shipments"
              ref="distribution.center.tab.all.shipments"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-house"></i>
            </template>
            {{ $t("Sidebar.ລາຍການຍິງເຄື່ອງເຂົ້າ - ອອກ") }}
          </vs-sidebar-item>
        </div>
        <div
            v-if="
            $can([
              'SuperAdmin',
              'distributioncentermanager',
              'distribution',
              'service',
            ])
          "
        >
          <vs-sidebar-item id="distribution.center.shipment.bag">
            <template #icon>
              <i class="fal fa-gift"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຍການກະເປົ໋າ") }}
          </vs-sidebar-item>
          <vs-sidebar-item id="distribution.center.shipment.bag.reusable">
            <template #icon>
              <i class="fas fa-recycle"></i>
            </template>
            {{ $t("Sidebar.ລາຍການກະເປົ໋າຫມຸນໃຊ້ໄດ້") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <!-- End DistributionCenters -->

      <vs-sidebar-group v-if="$can(['accountingcod', 'callcentervipcustomer'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-user"></i>
            </template>
            {{ $t("Sidebar.ລາຍການອະນຸມັດລູກຄ້າ COD Auto") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['accountingcod', 'callcentervipcustomer'])">
          <vs-sidebar-item id="tab.auto.approved.cod">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ລາຍການລູກຄ້າ COD") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingcod'])">
          <vs-sidebar-item id="list.account.bank">
            <template #icon>
              <i class="fal fa-piggy-bank"></i>
            </template>
            {{ $t("Sidebar.ລາຍການບັນຊີລູກຄ້າ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['accountingmanager', 'SuperAdmin'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-user"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ KYC") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item id="tab.user.kyc">
            <template #icon>
              <i class="fal fa-user"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ KYC ລູກຄ້າ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!-- Accounting Manager -->
      <vs-sidebar-group v-if="$can(isAccounting())">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-dolly-flatbed-alt"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ Order ພັດສະດຸ") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item v-if="$can(isAccounting())"
                           id="account.tab.all.shipments"
                           ref="account.tab.all.shipments"
                           :value="JSON.stringify({ query: { tab: tabQueryShipment } })"
          >
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນ ລາຍການ orders") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item
              id="account.tab.solve.shipments"
              ref="account.tab.solve.shipments"
              :value="JSON.stringify({ query: { tab: tabQueryShipment } })"
          >
            <template #icon>
              <i class="fal fa-engine-warning"></i>
            </template>
            {{ $t("Sidebar.ຄົ້ນຫາບິນ") }}
          </vs-sidebar-item>
        </div>
        <!--        report-->
        <div v-if="$can('accountingmanager')">
          <vs-sidebar-item
              id="account.tab.report.driver"
              ref="account.tab.report.driver"
              :value="JSON.stringify({ query: { tab: tabQueryShipment } })"
          >
            <template #icon>
              <i class="fal fa-truck"></i>
            </template>
            {{ $t("Sidebar.ລາຍການອໍເດີໂຊເພີລົດໃຫຍ່") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can('accountingmanager')">
          <vs-sidebar-item
              id="account.tab.report.distribution"
              ref="account.tab.report.distribution"
              :value="JSON.stringify({ query: { tab: tabQueryShipment } })"
          >
            <template #icon>
              <i class="fal fa-house"></i>
            </template>
            {{ $t("Sidebar.ລາຍການຍິງເຄື່ອງເຂົ້າ-ອອກ ສູນຄັດແຍກ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(isAccounting())">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-file-invoice-dollar"></i>
            </template>
            {{ $t("Sidebar.Invoices") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item
              id="account.tab.list.shipment"
              ref="account.tab.list.shipment"
              :value="JSON.stringify({ query: { tab: tabQueryInvoice } })"
          >
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.Orders ທີ່ຈະດຶງ Invoices") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item
              id="account.tab.list.order"
              ref="account.tab.list.order"
              :value="JSON.stringify({ query: { tab: tabQueryInvoice } })"
          >
            <template #icon>
              <i class="fal fa-badge-dollar"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ Invoices") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['accountingcod'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-file-invoice"></i>
            </template>
            {{ $t("Sidebar.invoice_customer_cod_list") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item
              id="accounting.pending.customer.cod.invoice.payment"
              ref="accounting.pending.customer.cod.invoice.payment"
              :value="JSON.stringify({ query: { tab: 'all' } })">
            <template #icon>
              <i class="fal fa-clock"></i>
            </template>
            {{ $t("Sidebar.pending_transfer_cod_balance_request") }}
          </vs-sidebar-item>
          <vs-sidebar-item
              id="accounting.success.customer.cod.invoice.payment"
              ref="accounting.success.customer.cod.invoice.payment"
              :value="JSON.stringify({ query: { tab: 'all' } })">
            <template #icon>
              <i class="fal fa-money-check-edit-alt"></i>
            </template>
            {{ $t("Sidebar.success_transfer_cod_balance_request") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['accountingcod'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-tools"></i>
            </template>
            {{ $t("Sidebar.utilities") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item id="hard.reset.password">
            <template #icon>
              <i class="fal fa-key"></i>
            </template>
            {{ $t("Sidebar.hard_reset_password") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!-- End Accounting Manager -->

      <vs-sidebar-group v-if="$can(['accountingmanager', 'accounting-local'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-file-invoice"></i>
            </template>
            {{ $t("Sidebar.Invoices ສາຂາຈຸດແຈກຢາຍ") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item
              id="tab.insert.invoice.local"
              ref="tab.insert.invoice.local"
              :value="JSON.stringify({ query: { tab: 'origin' } })"
          >
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.Orders ທີ່ຈະດຶງ Invoices") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item
              id="tab.invoice.local"
              ref="tab.invoice.local"
              :value="JSON.stringify({ query: { tab: 'origin' } })"
          >
            <template #icon>
              <i class="fal fa-badge-dollar"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ Invoices") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group
          v-if="$can(['accountingmanager', 'accountingoriginfranchise'])"
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-code-branch"></i>
            </template>
            {{ $t("Sidebar.Invoices ຍອດສຳເລັດຕົ້ນທາງແຟນຊາຍ") }}
          </vs-sidebar-item>
        </template>
        <div>
          <vs-sidebar-item
              id="tab.insert.invoice.franchise"
              ref="tab.insert.invoice.franchise"
              :value="JSON.stringify({ query: { tab: 'origin' } })"
          >
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.Orders ທີ່ຈະດຶງ Invoices") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item
              id="tab.invoice.franchise"
              ref="tab.invoice.franchise"
              :value="JSON.stringify({ query: { tab: 'origin' } })"
          >
            <template #icon>
              <i class="fal fa-badge-dollar"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ Invoices") }}
          </vs-sidebar-item>
        </div>
        <!-- Narrower than the group above on purpose: the API behind this screen
             is role:accountingoriginfranchise only, so showing it to
             accountingmanager would offer a menu entry that 403s. -->
        <div v-if="$can(['accountingoriginfranchise'])">
          <vs-sidebar-item id="franchise.success.origin.index">
            <template #icon>
              <i class="fal fa-file-chart-line"></i>
            </template>
            {{ $t("Sidebar.origin_delivered_summary") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <!-- End Accounting Manager -->

      <!--      Chart Report-->
      <vs-sidebar-group
          v-if="
          $can([
            'SuperAdmin',
            'manager',
            'service',
            'marketing-viewer',
            'head-franchise',
            'accountingmanager',
            'accountingcod'
          ])
        "
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-chart-bar"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານແບບ Graph") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'manager', 'service', 'accountingmanager'])">
          <vs-sidebar-item id="graph.report">
            <template #icon>
              <i class="fal fa-chart-line"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານແບບ Graph") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['marketing-viewer', 'SuperAdmin', 'head-franchise'])">
          <vs-sidebar-item id="shipment.qty.graph">
            <template #icon>
              <i class="fal fa-chart-bar"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານຍອດ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('SuperAdmin')">
          <vs-sidebar-item id="employee.registration.kpi">
            <template #icon>
              <i class="fal fa-user-chart"></i>
            </template>
            {{ $t("employeeRegistrationKpi.menu_label") }}
          </vs-sidebar-item>
        </div>
        <div
          v-if="
            $can([
              'distributioncentermanager',
              'distributioncenteruser',
              'branchmanager',
              'franchise-manager',
              'branchuser',
              'SuperAdmin',
              'manager',
              'accountingmanager',
              'province-manager',
            ])
          "
        >
          <vs-sidebar-item id="daily.creation.report">
            <template #icon>
              <i class="fal fa-clipboard-list"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານຍອດສ້າງປະຈຳວັນ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'service', 'manager'])">
          <vs-sidebar-item id="coo.delivery.speed">
            <template #icon>
              <i class="fal fa-tachometer-alt"></i>
            </template>
            {{ $t("deliverySpeed.menu_label") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'service', 'manager'])">
          <vs-sidebar-item id="transit.time.report">
            <template #icon>
              <i class="fal fa-truck-loading"></i>
            </template>
            {{ $t("transitTimeReport.menu_label") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'service', 'manager'])">
          <vs-sidebar-item id="creation.summary.report">
            <template #icon>
              <i class="fal fa-chart-bar"></i>
            </template>
            {{ $t("creationSummaryReport.menu_label") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'service', 'manager'])">
          <vs-sidebar-item id="frozen.shipments.report">
            <template #icon>
              <i class="fal fa-snowflake"></i>
            </template>
            {{ $t("frozenShipment.menu_label") }}
          </vs-sidebar-item>
        </div>
        <!-- ສິດເງິນດ່ວນ COD — roles MUST match the API gate
             (role:SuperAdmin|service|manager|accountingcod|accountingmanager).
             NEVER 'vipcustomer': it is the CUSTOMER app role (removed 2026-10-16). -->
        <div v-if="$can(['SuperAdmin', 'service', 'manager', 'accountingcod', 'accountingmanager'])">
          <vs-sidebar-item id="cod.advance.report">
            <template #icon>
              <i class="fal fa-hand-holding-usd"></i>
            </template>
            {{ $t("Sidebar.cod_advance_report") }}
          </vs-sidebar-item>
        </div>
        <div></div>
      </vs-sidebar-group>

      <!-- ຖອນເງິນ COD ລ່ວງໜ້າ — its own group, not a report. The roles here MUST
           match the endpoint gate (role SuperAdmin|accountingcod + the
           manage-cod-advance permission for enrollment/audit; the queue also
           allows callcentervipcustomer and accountingmanager (2026-10-16); the shops page also opens to manager,
           who approves shop changes — owner 2026-10-05). The GROUP condition is
           the union of the items', so it never renders as an empty header. -->
      <vs-sidebar-group
        v-if="$can(['SuperAdmin', 'accountingcod', 'callcentervipcustomer', 'accountingmanager', 'manager'])"
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-sack-dollar"></i>
            </template>
            {{ $t("Sidebar.cod_advance_group") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'accountingcod', 'manager'])">
          <vs-sidebar-item id="cod.advance.shops">
            <template #icon>
              <i class="fal fa-store"></i>
            </template>
            {{ $t("Sidebar.cod_advance_shops") }}
          </vs-sidebar-item>
        </div>
        <!-- The boss's ceilings (2026-10-26): set by ຜູ້ບໍລິຫານ / SuperAdmin only. Finance
             reads them in the shop form instead — the save route refuses its roles. -->
        <div v-if="$can(['SuperAdmin', 'manager'])">
          <vs-sidebar-item id="cod.advance.policy">
            <template #icon>
              <i class="fal fa-sliders-h"></i>
            </template>
            {{ $t("Sidebar.cod_advance_policy") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'accountingcod', 'callcentervipcustomer', 'accountingmanager'])">
          <vs-sidebar-item id="cod.advance.transfers">
            <template #icon>
              <i class="fal fa-money-check-alt"></i>
            </template>
            {{ $t("Sidebar.cod_advance_transfers") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--Accountant Manager-->
      <vs-sidebar-group v-if="$can(['accountingmanager', 'SuperAdmin'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-chart-line"></i>
            </template>
            {{ $t("Sidebar.ສະຫຼຸບບັນຊີ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['accountingmanager'])">
          <vs-sidebar-item id="accountant.summary.branch">
            <template #icon>
              <i class="fal fa-home"></i>
            </template>
            {{ $t("Sidebar.ຄິດໄລ່ຍອດສາຂາ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager'])">
          <vs-sidebar-item id="accountant.summary.distribution">
            <template #icon>
              <i class="fal fa-warehouse-alt"></i>
            </template>
            {{ $t("Sidebar.ຄິດໄລ່ຍອດສູນຄັດແຍກ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager'])">
          <vs-sidebar-item id="accountant.summary.delivery.capital">
            <template #icon>
              <i class="fal fa-biking"></i>
            </template>
            {{ $t("Sidebar.ຄິດໄລ່ຍອດ delivery ນ/ຄຫຼວງ ລົດຈັກ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager'])">
          <vs-sidebar-item id="accountant.summary.driver.capital">
            <template #icon>
              <i class="fal fa-truck"></i>
            </template>
            {{ $t("Sidebar.ຄິດໄລ່ຍອດ delivery ນ/ຄຫຼວງ ລົດໃຫຍ່") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager'])">
          <vs-sidebar-item id="accountant.summary.delivery.province">
            <template #icon>
              <i class="fal fa-bicycle"></i>
            </template>
            {{ $t("Sidebar.ຄິດໄລ່ຍອດ delivery ຕ່າງແຂວງລົດຈັກ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager'])">
          <vs-sidebar-item id="accountant.summary.driver.province">
            <template #icon>
              <i class="fal fa-truck"></i>
            </template>
            {{ $t("Sidebar.ຄິດໄລ່ຍອດ delivery ຕ່າງແຂວງລົດໃຫຍ່") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--Branch Wallet Management-->
      <vs-sidebar-group v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-wallet"></i>
            </template>
            {{ $t("Sidebar.ກະເປົ໋າສາຂາ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="list.branch.wallets">
            <template #icon>
              <i class="fal fa-coins"></i>
            </template>
            {{ $t("Sidebar.ຈັດການກະເປົ໋າສາຂາ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.treasury.dashboard">
            <template #icon>
              <i class="fal fa-balance-scale"></i>
            </template>
            {{ $t("Sidebar.bank_reconciliation") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.all.transactions">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.all_records") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.bank.config">
            <template #icon>
              <i class="fal fa-university"></i>
            </template>
            {{ $t("Sidebar.bank_settings") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.audit.logs">
            <template #icon>
              <i class="fal fa-clipboard-list"></i>
            </template>
            {{ $t("Sidebar.operation_log") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.pending.topups">
            <template #icon>
              <i class="fal fa-clock"></i>
            </template>
            {{ $t("Sidebar.pending_top_up") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin'])">
          <vs-sidebar-item id="wallet.job.dashboard">
            <template #icon>
              <i class="fal fa-tasks"></i>
            </template>
            Job Dashboard
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.holidays">
            <template #icon>
              <i class="fal fa-calendar-star"></i>
            </template>
            {{ $t("Sidebar.holidays") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--Wallet Monitor (read-only reporting)-->
      <vs-sidebar-group v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-chart-line"></i>
            </template>
            {{ $t("Sidebar.wallet_monitor") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.monitor.summary">
            <template #icon>
              <i class="fal fa-chart-pie"></i>
            </template>
            {{ $t("Sidebar.summary") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.monitor.transactions">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.transactions") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.monitor.balance">
            <template #icon>
              <i class="fal fa-balance-scale"></i>
            </template>
            {{ $t("Sidebar.balance") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin', 'accountingoriginfranchise', 'accountingcdc', 'accountingoriginbranch', 'accountingcod'])">
          <vs-sidebar-item id="wallet.monitor.export">
            <template #icon>
              <i class="fal fa-file-export"></i>
            </template>
            Export Excel
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--Accountant cdc-->
      <vs-sidebar-group v-if="$can(['accountingcdc'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-chart-line"></i>
            </template>
            {{ $t("Sidebar.ສະຫຼຸບບັນຊີ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['accountingcdc'])">
          <vs-sidebar-item id="cdc.summary.branch">
            <template #icon>
              <i class="fal fa-home"></i>
            </template>
            {{ $t("Sidebar.ຄິດໄລ່ຍອດສາຂາ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--      Marketing-->
      <vs-sidebar-group
          v-if="
          $can([
            'marketing',
            'accountingcod',
            'accountingmanager',
            'suburbMarketing',
          ])
        "
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-money-check"></i>
            </template>
            {{ $t("Sidebar.ການຕະຫຼາດ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['marketing', 'accountingmanager', 'suburbMarketing'])">
          <vs-sidebar-item id="marketing.regular.customer">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ລາຍການລູກຄ້າເຊັນສັນຍາ") }}
          </vs-sidebar-item>
        </div>
        <div
            v-if="
            $can([
              'marketing',
              'accountingcod',
              'accountingmanager',
              'suburbMarketing',
            ])
          "
        >
          <vs-sidebar-item
              id="marketing.tab.shipment"
              ref="marketing.tab.shipment"
              :value="JSON.stringify({ query: { tab: 'all' } })"
          >
            <template #icon>
              <i class="fal fa-cash-register"></i>
            </template>
            {{ $t("Sidebar.ລາຍການພັດສະດຸລູກຄ້າເຊັນສັນຍາ") }}
          </vs-sidebar-item>
        </div>
        <div
            v-if="
            $can([
              'marketing',
              'accountingcod',
              'accountingmanager',
              'suburbMarketing',
            ])
          "
        >
          <vs-sidebar-item id="marketing.regular.summary">
            <template #icon>
              <i class="fal fa-chart-line"></i>
            </template>
            {{ $t("Sidebar.ສະຫຼຸບຍອດລູກຄ້າເຊັນສັນຍາ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--      Report Marketing-->
      <vs-sidebar-group v-if="$can(['SuperAdmin', 'accountingcod'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-poll-people"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານຂໍ້ມູນລູກຄ້າ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'accountingcod'])">
          <vs-sidebar-item id="admin.list.customer">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນລູກຄ້າ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--POINT-->
      <vs-sidebar-group v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-star"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານຂໍ້ມູນຄະແນນລູກຄ້າ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="list.point">
            <template #icon>
              <i class="fal fa-award"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນຄະແນນ") }}
          </vs-sidebar-item>
        </div>
        <!--        <div v-if="$can(['SuperAdmin','manager', 'marketing'])">-->
        <!--          <vs-sidebar-item id="list.all.transaction">-->
        <!--            <template #icon>-->
        <!--              <i class='fal fa-exchange'></i>-->
        <!--            </template>-->
        <!--            ຂໍ້ມູນການເຄື່ອນໄຫວຄະແນນ-->
        <!--          </vs-sidebar-item>-->
        <!--        </div>-->
        <div v-if="$can(['SuperAdmin', 'marketing'])">
          <vs-sidebar-item id="print.all.point.transaction">
            <template #icon>
              <i class="fal fa-coins"></i>
            </template>
            {{ $t("Sidebar.Export ການເຄື່ອນໄຫວຄະແນນ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!--INTERN MARKETING-->
      <vs-sidebar-group v-if="$can('headinternmarketing')">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-poll-people"></i>
            </template>
            {{ $t("Sidebar.ຂໍ້ມູນນັກສຶກສາຝຶກງານ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can('headinternmarketing')">
          <vs-sidebar-item id="list.intern.marketing">
            <template #icon>
              <i class="fal fa-user-alt"></i>
            </template>
            {{ $t("Sidebar.ລາຍຊື່ນັກສຶກສາ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('headinternmarketing')">
          <vs-sidebar-item id="list.intern.register">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ລາຍການລົງທະບຽນ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['manager', 'accountingcod'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-cash-register"></i>
            </template>
            {{ $t("Sidebar.ສະຫຼຸບຍອດ COD") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['accountingcod', 'manager'])">
          <vs-sidebar-item id="list.cod.customer.shipment">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ຍອດ COD ລູກຄ້າ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingcod'])">
          <vs-sidebar-item id="list.summary.cod">
            <template #icon>
              <i class="fal fa-house"></i>
            </template>
            {{ $t("Sidebar.ຍອດ COD ສາຂາ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group
          v-if="
          $can([
            'SuperAdmin',
            'manager',
            'marketing',
            'marketinghelper',
            'shop-user',
            'shop-manager',
            'service',
            'accountingmanager',
            'accountingcod',
            'accountingcdc',
            'accountingoriginfranchise',
            'accountingoriginbranch',
          ])
        "
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-house-signal"></i>
            </template>
            {{ $t("Sidebar.ຮ້ານຄ້າ") }}
          </vs-sidebar-item>
        </template>
        <div
            v-if="$can(['SuperAdmin', 'manager', 'marketing', 'marketinghelper'])"
        >
          <vs-sidebar-item id="list.shop">
            <template #icon>
              <i class="fal fa-home"></i>
            </template>
            {{ $t("Sidebar.ຮ້ານຄ້າ") }}
          </vs-sidebar-item>
        </div>
        <div
            v-if="
            $can([
              'SuperAdmin',
              'manager',
              'marketing',
              'marketinghelper',
              'shop-user',
              'shop-manager',
              'service',
              'accountingmanager',
              'accountingcod',
              'accountingcdc',
              'accountingoriginfranchise',
              'accountingoriginbranch',
            ])
          "
        >
          <vs-sidebar-item id="shop.payment">
            <template #icon>
              <i class="fal fa-chart-bar"></i>
            </template>
            {{ $t("Sidebar.ຍອດຮ້ານຄ້າ") }}
          </vs-sidebar-item>
        </div>
        <div
            v-if="$can(['SuperAdmin', 'manager', 'marketing', 'marketinghelper'])"
        >
          <vs-sidebar-item id="list.shop.user">
            <template #icon>
              <i class="fal fa-user"></i>
            </template>
            {{ $t("Sidebar.ຜູ້ໃຊ້ສຳຫຼັບຮ້ານຄ້າຮ່ວມລາຍການ") }}
          </vs-sidebar-item>
        </div>
        <div
            v-if="$can(['SuperAdmin', 'manager', 'marketing', 'marketinghelper'])"
        >
          <vs-sidebar-item id="list.shop.item.category">
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.ປະເພດຂອງລາງວັນ") }}
          </vs-sidebar-item>
        </div>
        <div
            v-if="$can(['SuperAdmin', 'manager', 'marketing', 'marketinghelper'])"
        >
          <vs-sidebar-item id="list.shop.item">
            <template #icon>
              <i class="fal fa-gifts"></i>
            </template>
            {{ $t("Sidebar.ຂອງລາງວັນ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="list.exchange.item">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ປະຫວັດແລກຂອງລາງວັນ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-building"></i>
            </template>
            {{ $t("Sidebar.ຮ້ານຄ້າ Corporate") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="corporate.store">
            <template #icon>
              <i class="fal fa-store"></i>
            </template>
            {{ $t("Sidebar.ຈັດການຮ້ານຄ້າ") }}
          </vs-sidebar-item>
        </div>
        <!-- ລາຄາພິເສດສະເພາະລູກຄ້າ — same roles as the API (admin/customer-special-prices). -->
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="corporate.special.price">
            <template #icon>
              <i class="fal fa-tags"></i>
            </template>
            {{ $t("Sidebar.customer_special_price") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="corporate.employee.upload.reports">
            <template #icon>
              <i class="fal fa-upload"></i>
            </template>
            {{ $t("Sidebar.ລາຍງານການອັບໂຫລດ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="corporate.advance.cod.withdraw">
            <template #icon>
              <i class="fal fa-hand-holding-usd"></i>
            </template>
            {{ $t("codAdvance.menu_shops") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="corporate.cod.transfer.waiting">
            <template #icon>
              <i class="fal fa-money-check-alt"></i>
            </template>
            {{ $t("Sidebar.cod_transfer_waiting") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!-- External provider orders (ThunJai) — stakeholder dashboard + orders -->
      <vs-sidebar-group v-if="$can(['SuperAdmin', 'manager'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-truck"></i>
            </template>
            {{ $t("Sidebar.external_logistics") }}
          </vs-sidebar-item>
        </template>

        <div v-if="$can(['SuperAdmin', 'manager'])">
          <vs-sidebar-item id="external.dashboard">
            <template #icon>
              <i class="fal fa-analytics"></i>
            </template>
            {{ $t("Sidebar.report_dashboard") }}
          </vs-sidebar-item>
        </div>

        <div v-if="$can(['SuperAdmin', 'manager'])">
          <vs-sidebar-item id="external.orders">
            <template #icon>
              <i class="fal fa-boxes"></i>
            </template>
            {{ $t("Sidebar.order_list") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can('marketinghelper')">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-cash-register"></i>
            </template>
            {{ $t("Sidebar.ອິນວອຍຮ້ານຄ້າ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can('marketinghelper')">
          <vs-sidebar-item id="list.insert.shop.invoice">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ລາຍການທີ່ຈະສ້າງອິນວອຍ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can('marketinghelper')">
          <vs-sidebar-item id="list.shop.invoice">
            <template #icon>
              <i class="fal fa-money-bill"></i>
            </template>
            {{ $t("Sidebar.ອິນວອຍ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can('marketinghelper')">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-history"></i>
            </template>
            {{ $t("Sidebar.ປະຫວັດການຂາຍເລກ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can('marketinghelper')">
          <vs-sidebar-item id="list.lottery.history">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ລາຍການຂາຍເລກ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-box-heart"></i>
            </template>
            {{ $t("Sidebar.ກ່ອງລຸ້ນໂຊກ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="list.prize">
            <template #icon>
              <i class="fal fa-box"></i>
            </template>
            {{ $t("Sidebar.ຂອງລາງວັນ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'manager', 'marketing'])">
          <vs-sidebar-item id="list.prize.result">
            <template #icon>
              <i class="fal fa-history"></i>
            </template>
            {{ $t("Sidebar.ປະຫວັດການເປີດກ່ອງ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'service'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-calculator"></i>
            </template>
            {{ $t("Sidebar.calculate_freight") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'service'])">
          <vs-sidebar-item id="calculate.freight.index">
            <template #icon>
              <i class="fal fa-shipping-fast"></i>
            </template>
            {{ $t("Sidebar.calculate_freight_domestic") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'service'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-money-bill"></i>
            </template>
            {{ $t("Sidebar.Export ບິນ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin','service'])">
          <vs-sidebar-item id="print.all.shipment">
            <template #icon>
              <i class="fal fa-print"></i>
            </template>
            {{ $t("Sidebar.ລາຍການບິນ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
          <vs-sidebar-item id="print.shipment.from.capital">
            <template #icon>
              <i class="fal fa-shipping-fast"></i>
            </template>
            {{ $t("Sidebar.ລາຍການບິນນຄຫຼວງ-ຕ່າງແຂວງ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <vs-sidebar-group v-if="$can(['SuperAdmin', 'TaxViewer'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-list-alt"></i>
            </template>
            {{ $t("Sidebar.ລາຍການບິນແຍກຕາມສາຂາ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'TaxViewer'])">
          <vs-sidebar-item id="shipment.branch.quantities">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ລາຍການບິນສຳເລັດ") }}
          </vs-sidebar-item>
        </div>
        <div v-if="$can(['SuperAdmin', 'TaxViewer'])">
          <vs-sidebar-item id="shipment.branch.post.office.quantities">
            <template #icon>
              <i class="fal fa-envelope"></i>
            </template>
            {{ $t("Sidebar.ໄປສະນີ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <vs-sidebar-group v-if="$can(['halcenterlive'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-tv-retro"></i>
            </template>
            {{ $t("Sidebar.HAL CENTER LIVE") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['halcenterlive'])">
          <vs-sidebar-item id="hal.live.coupon">
            <template #icon>
              <i class="fal fa-credit-card-blank"></i>
            </template>
            {{ $t("Sidebar.ຄູປອງ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'news'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-award"></i>
            </template>
            {{ $t("Sidebar.ຈັດການໜ້າ Event") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'news'])">
          <vs-sidebar-item id="event.promotion">
            <template #icon>
              <i class="fal fa-list"></i>
            </template>
            {{ $t("Sidebar.ລາຍການ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <!--      <vs-sidebar-group v-if="$can('accountingcdc')">-->
      <!--        <template #header>-->
      <!--          <vs-sidebar-item arrow>-->
      <!--            <template #icon>-->
      <!--              <i class='fal fa-not-equal'></i>-->
      <!--            </template>-->
      <!--            ເຄື່ອງຕີກັບ CDC-->
      <!--          </vs-sidebar-item>-->
      <!--        </template>-->
      <!--        <div>-->
      <!--          <vs-sidebar-item id="list.reject.cdc.shipment">-->
      <!--            <template #icon>-->
      <!--              <i class='fal fa-list'></i>-->
      <!--            </template>-->
      <!--            ລາຍການເຄື່ອງຕີກັບ-->
      <!--          </vs-sidebar-item>-->
      <!--        </div>-->
      <!--      </vs-sidebar-group>-->

      <vs-sidebar-group v-if="$can(['SuperAdmin', 'hr', 'service', 'manager', 'marketing'])">
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-comment-alt-exclamation"></i>
            </template>
            {{ $t("Sidebar.ຄຳຕິຊົມ") }}
          </vs-sidebar-item>
        </template>
        <div v-if="$can(['SuperAdmin', 'hr', 'service', 'manager', 'marketing'])">
          <vs-sidebar-item id="feedback.index">
            <template #icon>
              <i class="fal fa-comment-alt-exclamation"></i>
            </template>
            {{ $t("Sidebar.ຄຳຕິຊົມສາຂາ") }}
          </vs-sidebar-item>
          <vs-sidebar-item id="feedback-user.index">
            <template #icon>
              <i class="fal fa-comment-alt-exclamation"></i>
            </template>
            {{ $t("Sidebar.ຄຳຕິຊົມພະນັກງານ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <vs-sidebar-group
          v-if="
          $can([
            'branchuser',
            'branchmanager',
            'franchise-manager',
            'distributioncenteruser',
            'distributioncentermanager',
            'service',
          ])
        ">
        <template #header>
          <vs-sidebar-item arrow v-if="!$can('organization-manager')">
            <template #icon>
              <i class="far fa-dolly"></i>
            </template>
            {{ $t("Sidebar.ຄັງພັດສະດຸ") }}
          </vs-sidebar-item>
        </template>
        <div>
          <div v-if="$can(['branchuser', 'service'])">
            <vs-sidebar-item id="parcelBranch.index">
              <template #icon>
                <i class="fal fa-scanner"></i>
              </template>
              {{ $t("Sidebar.ຄັງພັດສະດຸສາຂາ") }}
            </vs-sidebar-item>
          </div>
          <div
              v-if="
              $can([
                'distributioncenteruser',
                'distributioncentermanager',
                'service',
              ])
            "
          >
            <vs-sidebar-item id="parcelDistributionCenter.index">
              <template #icon>
                <i class="far fa-pallet-alt"></i>
              </template>
              {{ $t("Sidebar.ຄັງພັດສະດຸສູນຄັດແຍກ") }}
            </vs-sidebar-item>
          </div>
        </div>
      </vs-sidebar-group>

      <!-- Sorting System Group -->
      <vs-sidebar-group
        v-if="
          $can([
            'distributioncentermanager',
            'SuperAdmin',
            'service',
          ])
        "
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-sort-alt"></i>
            </template>
            {{ $t("Sidebar.ລະບົບຄັດແຍກ") }}
          </vs-sidebar-item>
        </template>

        <div>
          <vs-sidebar-item id="distribution.center.sorting.mode">
            <template #icon>
              <i class="far fa-cogs"></i>
            </template>
            {{ $t("Sidebar.ຈັດການການຄັດແຍກ") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="distribution.center.branch.dc.override">
            <template #icon>
              <i class="far fa-route"></i>
            </template>
            {{ $t("Sidebar.ຕັ້ງຄ່າເສັ້ນທາງສາຂາໄປຕ່າງແຂວງ") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="distribution.center.route.branch.management">
            <template #icon>
              <i class="far fa-code-branch"></i>
            </template>
            {{ $t("Sidebar.ຕັ້ງຄ່າເສັ້ນທາງພິເສດ") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>

      <!-- Fleet / Route / Trip TMS (001-fleet-route-trips)
           distributioncentermanager is the route/round/trip PLANNER and gets the
           whole menu, as do fleetmanager/fleetuser — DEDICATED planner roles
           with the same fleet endpoints and nothing else of a DC manager's
           surface (so this group is their entire sidebar). The money on these
           screens (ລາຄາ/ຖ້ຽວ, fuel amounts, unit costs) is the
           `view-fleet-cost` permission — seeded onto fleetmanager, never onto
           fleetuser or the DC manager — enforced field-by-field by the API and
           mirrored here with $canDo. -->
      <vs-sidebar-group
        v-if="$can(['SuperAdmin', 'service', 'distributioncentermanager', 'fleetmanager', 'fleetuser'])"
      >
        <template #header>
          <vs-sidebar-item arrow>
            <template #icon>
              <i class="fal fa-truck-container"></i>
            </template>
            {{ $t("Sidebar.tms") }}
          </vs-sidebar-item>
        </template>

        <div>
          <vs-sidebar-item id="fleet.trucks.index">
            <template #icon>
              <i class="fal fa-truck"></i>
            </template>
            {{ $t("Sidebar.fleet_trucks") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.routes.index">
            <template #icon>
              <i class="fal fa-route"></i>
            </template>
            {{ $t("Sidebar.fleet_routes") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.rounds.planner">
            <template #icon>
              <i class="fal fa-calendar-alt"></i>
            </template>
            {{ $t("Sidebar.fleet_round_planner") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.trips.board">
            <template #icon>
              <i class="fal fa-shipping-fast"></i>
            </template>
            {{ $t("Sidebar.fleet_trip_board") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.stops.incoming">
            <template #icon>
              <i class="fal fa-inbox-in"></i>
            </template>
            {{ $t("Sidebar.fleet_incoming_parcels") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.live">
            <template #icon>
              <i class="fal fa-map-marked-alt"></i>
            </template>
            {{ $t("Sidebar.fleet_live_tracking") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.reports.volume">
            <template #icon>
              <i class="fal fa-chart-bar"></i>
            </template>
            {{ $t("Sidebar.fleet_pending_volume") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.reports.daily">
            <template #icon>
              <i class="fal fa-file-spreadsheet"></i>
            </template>
            {{ $t("Sidebar.fleet_daily_report") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.reports.timetable">
            <template #icon>
              <i class="fal fa-business-time"></i>
            </template>
            {{ $t("Sidebar.fleet_timetable_report") }}
          </vs-sidebar-item>
        </div>
        <div>
          <vs-sidebar-item id="fleet.reports.problems">
            <template #icon>
              <i class="fal fa-exclamation-triangle"></i>
            </template>
            {{ $t("Sidebar.fleet_driver_problems") }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar-group>
      <!-- Fleet / Route / Trip TMS -->

      <div
          v-if="$can(['SuperAdmin', 'manager', 'marketing', 'marketinghelper'])"
      >
        <vs-sidebar-item id="referralRegister.index">
          <template #icon>
            <i class="fal fa-user-chart"></i>
          </template>
          {{ $t("Sidebar.ລາຍການແນະນຳລູກຄ້າລົງທະບຽນໃໝ່") }}
        </vs-sidebar-item>
      </div>
      <div v-if="$can(['SuperAdmin', 'marketing'])">
        <vs-sidebar-item id="customer.shipment.total">
          <template #icon>
            <i class="fal fa-money-bill"></i>
          </template>
          {{ $t("Sidebar.ລາຍການຍອດຝາກລູກຄ້າ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['data-viewer', 'SuperAdmin'])">
        <vs-sidebar-item id="weekly.data.report">
          <template #icon>
            <i class="fal fa-file-spreadsheet"></i>
          </template>
          {{ $t("Sidebar.data_report") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'service'])">
        <vs-sidebar-item id="route.shipment.report.index">
          <template #icon>
            <i class="fal fa-route"></i>
          </template>
          {{ $t("Sidebar.route_shipment_report") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'service'])">
        <vs-sidebar-item id="confirmReceiveParcel.index">
          <template #icon>
            <i class="fal fa-box-check"></i>
          </template>
          {{ $t("Sidebar.confirm_receive_parcel") }}
        </vs-sidebar-item>
      </div>

      <!--
        ONE entry for the new claim line, not one per desk.

        It was briefly two — ຮັບຄຳຮ້ອງ and ປະເມີນຄຳຮ້ອງ — and they were the same screen twice: same
        queue, same rows, differing by a heading. Two menu entries that open the same list teach
        somebody to click the wrong one.

        What actually separates the two jobs is which BUTTONS appear, and those are decided by the
        claim's own permission map from the server. So the section is one door, open to anyone who
        works claims, and the authority shows up where the work is.

        The legacy collection list below keeps its own name — during the run-off these two are the
        confusable pair, and that is what this comment is for.
      -->
      <div v-if="$can(['SuperAdmin', 'injured-parcel-user', 'file-claim', 'assess-claim'])">
        <vs-sidebar-item id="claim.index">
          <template #icon>
            <i class="far fa-box-open"></i>
          </template>
          {{ $t("Sidebar.ຄຳຮ້ອງຊົດເຊີຍພັດສະດຸ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'injured-parcel-user'])">
        <vs-sidebar-item id="injuredParcel.index">
          <template #icon>
            <i class="far fa-clipboard-list"></i>
          </template>
          {{ $t("Sidebar.ລາຍການເກັບກຳເຄື່ອງເສຍຫາຍ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['accountingmanager', 'marketing'])">
        <vs-sidebar-item id="vendor.bill.index">
          <template #icon>
            <i class="fal fa-ballot-check"></i>
          </template>
          {{ $t("Sidebar.ບິນຈາກຮ້ານຄ້າ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['accountingmanager'])">
        <vs-sidebar-item id="lcr.shipments.index">
          <template #icon>
            <i class="fal fa-calculator"></i>
          </template>
          {{ $t("Sidebar.ຍອດຂົນສົ່ງທາງລົດໄຟ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['accountingmanager'])">
        <vs-sidebar-item id="plane.shipments.index">
          <template #icon>
            <i class="fal fa-plane"></i>
          </template>
          {{ $t("Sidebar.ຍອດຂົນສົ່ງທາງຍົນ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'settle-shipment-status-manager'])">
        <vs-sidebar-item id="shipment.settlement.index">
          <template #icon>
            <i class="fal fa-money-check"></i>
          </template>
          {{ $t("Sidebar.ບິນຮຽກເກັບເງິນ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'settle-shipment-status-manager'])">
        <vs-sidebar-item id="auto.sign.shipment.index">
          <template #icon>
            <i class="fal fa-signature"></i>
          </template>
          {{ $t("Sidebar.ສໍານັກງານໃຫຍ່ສໍາເລັດບິນAuto") }}
        </vs-sidebar-item>
      </div>

      <!-- Sits beside the auto-sign entry on purpose: this line is what tells an
           auto-signed bill apart from one a person actually keyed. -->
      <div v-if="$can(['SuperAdmin', 'manager', 'view-delivery-proof'])">
        <vs-sidebar-item id="delivery.proof.queue">
          <template #icon>
            <i class="fal fa-inbox-in"></i>
          </template>
          {{ $t("Sidebar.ກວດການຢືນຢັນຮັບພັດສະດຸ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'manager', 'view-delivery-proof'])">
        <vs-sidebar-item id="delivery.proof.report">
          <template #icon>
            <i class="fal fa-box-check"></i>
          </template>
          {{ $t("Sidebar.ຢືນຢັນຮັບພັດສະດຸຈາກລູກຄ້າ") }}
        </vs-sidebar-item>
      </div>

      <!-- Which senders the feature is open for at all.
           Roles ONLY, deliberately: `view-delivery-proof` opens the two READ
           screens above, and choosing which senders the feature is open for is a
           different power. The API gates this one on the roles alone too.
           DELIBERATELY NOT REVEALED YET: the four endpoints behind this screen
           ship with `hal-logistics-backend` → `gate-delivery-proof-by-sender`,
           which is not deployed. Until it is, the screen can only show its error
           line. Uncomment when the backend is up (that change's task 6.1 is
           enrolling the pilot senders through this very screen).
           The route itself is already registered, so the address works for
           whoever needs it before then. -->
      <!--
      <div v-if="$can(['SuperAdmin', 'manager'])">
        <vs-sidebar-item id="delivery.proof.senders">
          <template #icon>
            <i class="fal fa-user-check"></i>
          </template>
          {{ $t("Sidebar.ຜູ້ຝາກທີ່ເປີດໃຫ້ຢືນຢັນຮັບ") }}
        </vs-sidebar-item>
      </div>
      -->

      <div v-if="$can(['SuperAdmin', 'cleared-shipment-status-manager'])">
        <vs-sidebar-item id="shipment.cleared.index">
          <template #icon>
            <i class="far fa-dolly"></i>
          </template>
          {{ $t("Sidebar.ສະສາງພັດສະດຸ") }}
        </vs-sidebar-item>
      </div>
      <div v-if="$can(['SuperAdmin', 'settle-shipment-status-manager'])">
        <vs-sidebar-item id="shipment.blocked.sign.index">
          <template #icon>
            <i class="far fa-shield-alt"></i>
          </template>
          {{ $t("Sidebar.ລັອກເຊັນຮັບພັດສະດຸ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'import-sign-shipment-admin', 'import-sign-shipment'])">
        <vs-sidebar-item id="import.sign.shipment.index">
          <template #icon>
            <i class="fal fa-file-signature"></i>
          </template>
          {{ $t("Sidebar.ນຳເຂົ້າເລກບິນເພື່ອເຊັນສຳເລັດ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['SuperAdmin', 'import-sign-shipment-admin', 'import-sign-shipment'])">
        <vs-sidebar-item id="import.sign.branch.shipment.index">
          <template #icon>
            <i class="fal fa-file-import"></i>
          </template>
          {{ $t("Sidebar.ນຳເຂົ້າເລກບິນເພື່ອເຊັນເຂົ້າສາຂາຂອງຕົນ") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['accountingcdc'])">
        <vs-sidebar-item id="franchise.owner.index">
          <template #icon>
            <i class="fal fa-store-alt"></i>
          </template>
          {{ $t("Sidebar.franchise_owners") }}
        </vs-sidebar-item>
      </div>

      <div v-if="$can(['accountingmanager', 'SuperAdmin'])">
        <vs-sidebar-item id="give.back.franchises.index">
          <template #icon>
            <i class="fal fa-hand-holding-usd"></i>
          </template>
          {{ $t("Sidebar.dividends") }}
        </vs-sidebar-item>
      </div>

      <!--      <div-->
      <!--          v-if="($can('accountingcod') || $can('branchmanager') || $can('franchise-manager')) && !$can('organization-manager') && $i18n.locale !== 'CN'">-->
      <!--        <vs-sidebar-item id="cod.branches.balance.index">-->
      <!--          <template #icon>-->
      <!--            <i class="fal fa-money-bill"></i>-->
      <!--          </template>-->
      <!--          ລາຍລະອຽດສ່ວນແບ່ງ COD-->
      <!--        </vs-sidebar-item>-->
      <!--      </div>-->

      <!--
        ຕັ້ງຄ່າລະບົບ — deliberately LAST and on its own, not inside any group above.
        Those groups are day-to-day operational data; this is configuration that changes a few
        times a year and reaches across the whole system, so it does not belong beside them.
        SuperAdmin plus the finance heads (accountingcod, accountingoriginfranchise), matching the
        role list the API enforces on api/admin/return-rule-settings and
        api/admin/auto-sign-excluded-branches — change both or neither. One entry for every
        settings section — the page carries its own side menu for those.
      -->
      <div v-if="$can(['SuperAdmin', 'accountingcod', 'accountingoriginfranchise'])">
        <vs-sidebar-item id="settings.index">
          <template #icon>
            <i class="fal fa-cog"></i>
          </template>
          {{ $t("Sidebar.ຕັ້ງຄ່າລະບົບ") }}
        </vs-sidebar-item>
      </div>

    </vs-sidebar>
  </div>
</template>
<script>
export default {
  data: () => ({
    active: "",
    changeByRoute: false,
    tabQueryInvoice: "",
    tabQueryShipment: "",
  }),
  watch: {
    active() {
      let optionals = {};
      const ref = this.$refs[this.active];
      const {params, query} = this.$route;
      if (ref) {
        optionals = JSON.parse(ref.value);
      }
      if (this.changeByRoute) {
        optionals.params = {...optionals.params, ...params};
        optionals.query = {...optionals.query, ...query};
        this.changeByRoute = false;
      }
      this.$router.push({name: this.active, ...optionals}).catch(() => {
      });
    },
    "$route.name": function (name) {
      if (name !== this.active) {
        this.changeByRoute = true;
        this.activeSidebarMenuItem(name);
      }
    },
  },
  methods: {
    activeSidebarMenuItem(name) {
      if (name) {
        this.active = name;
        const ref = this.$refs.sidebar;
        if (ref) {
          const children = ref.$children;
          children.map((group) => {
            const activeChildGroup = group.$children.filter(
                (menu) => menu.id === name
            );
            if (activeChildGroup.length) {
              group.openState = true;
            }
          });
        }
      }
    },
    isAccountingAndAdmin() {
      return [
        "SuperAdmin",
        "accountingmanager",
        "accountingoriginbranch",
        "accountingoriginfranchise",
        "accountingcdc",
        "accountingcod",
      ];
    },
    isAccounting() {
      return [
        "accountingmanager",
        "accountingoriginbranch",
        "accountingoriginfranchise",
        "accountingcdc",
        "accountingcod",
      ];
    },
    isBranchCLogisticsAccounting() {
      return [
        "c-logistics-branch-accounting"
      ];
    },
  },
  mounted() {
    const {name} = this.$route;
    this.changeByRoute = true;
    this.activeSidebarMenuItem(name);

    //forInvoiceTab
    if (
        this.$can([
          "accountingmanager",
          "accountingoriginbranch",
          "accountingoriginfranchise",
        ])
    ) {
      this.tabQueryInvoice = "origin_freight";
      this.tabQueryInvoiceLocal = "origin";
    } else if (this.$can("accountingcdc")) {
      this.tabQueryInvoice = "destination_freight";
    } else {
      this.tabQueryInvoice = "parcel_price";
    }

    //forShipmentTab
    if (this.$can(["accountingoriginbranch", "accountingoriginfranchise"])) {
      this.tabQueryShipment = "origin_freight_fees";
    } else if (this.$can("accountingcdc")) {
      this.tabQueryShipment = "destination_freight_fees";
    } else if (this.$can("accountingcod")) {
      this.tabQueryShipment = "origin_freight_fees_cod";
    } else {
      this.tabQueryShipment = "all";
    }
  },
};
</script>

<style lang="scss">
.vs-sidebar__group__content {
  margin-left: 5px;
}
</style>
